export default function selectJiraArePrioritiesLoading(state, { source }) {
  return state.integrations.thirdPartyData[source].priorities.loading
}
